export const defaultValue = {
  storeId: 0,
  customerId: 0,
  productId: 0,
  orderDate: new Date().toISOString().slice(0, 10),
  deadline: "",
  remarks: "",
  delivery: "",
  deposit: "",
  repairFee: "",
  guest: false,
  guestName: "",
  pantsWaistAdjustment: 0,
  pantsWaistRise: 0,
  pantsWaist: "",
  hipAdjustment: 0,
  hipRise: 0,
  hip: "",
  buttocksAdjustment: 0,
  buttocksRise: 0,
  buttocks: "",
  inseamAdjustment: 0,
  inseamRise: 0,
  inseam: "",
  cuffAdjustment: 0,
  cuffRise: 0,
  cuff: "",
  kneeWidthAdjustment: 0,
  kneeWidthRise: 0,
  kneeWidth: "",
  hemWidthAdjustment: 0,
  hemWidthRise: 0,
  hemWidth: "",
  sleeveRightAdjustment: 0,
  sleeveRightRise: 0,
  sleeveRight: "",
  sleeveLeftAdjustment: 0,
  sleeveLeftRise: 0,
  sleeveLeft: "",
  bustAdjustment: 0,
  bustRise: 0,
  bust: "",
  jacketWaistAdjustment: 0,
  jacketWaistRise: 0,
  jacketWaist: "",
  kemawashiAdjustment: 0,
  kemawashiRise: 0,
  kemawashi: "",
  lengthAdjustment: 0,
  lengthRise: 0,
  length: "",
  payments: [],
}
